module.exports = __webpack_public_path__ + "static/media/img_car_2_desktop.9855ad6a.png";